export class ModifyString {
  capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
}



// WEBPACK FOOTER //
// ./src/methods/CapitalizeFirstLetter.js